import React, { Fragment, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import {
  Calendar,
  Views,
  DateLocalizer,
  momentLocalizer,
} from "react-big-calendar";
// import 'react-big-calendar/lib/css/react-big-calendar.css';
import { useState } from "react";
import { Card, CardBody } from "reactstrap";
import "./Calender.css";
import CustomToolbar from "./CustomToolbar";
import {
  Avatar,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  Add,
  BeachAccess,
  Close,
  Delete,
  Done,
  ViewAgenda,
  Visibility,
  Work,
} from "@material-ui/icons";
import { Pending, Person } from "@mui/icons-material";
import { post } from "../../../_helper/api_helper";
import { useNavigate, useParams } from "react-router-dom";
import { loadingPanel } from "../../../CommonComponents/CommonFunction";
import EventComponent from "./EventComponent";
import { useAuth } from "oidc-react";

const mLocalizer = momentLocalizer(moment);
// const events = [
//   /* {
//     id: 0,
//     allDay: true ,
//     title: 'All Day Event very long title',
//     allDay: true,
//     start: new Date(2024, 3, 0),
//     end: new Date(2024, 3, 1),
//   }, */
//   {
//     id: 1,
//     allDay: true,
//     title: 'Long Event',
//     start: new Date(2024, 6, 4),
//     end: new Date(2024, 6, 4),
//   },

//   {
//     id: 2,
//     allDay: true,
//     title: 'DTS STARTS',
//     start: new Date(2024, 6, 4),
//     end: new Date(2024, 6, 4)
//   },

//   {
//     id: 3,
//     allDay: true,
//     title: 'DTS ENDS',
//     start: new Date(2024, 6, 4),
//     end: new Date(2024, 6, 4),
//   },

//   {
//     id: 4,
//     allDay: true,
//     title: 'Some Event',
//     start: new Date(2024, 6, 4),
//     end: new Date(2024, 6, 4),
//     allDay: true,
//   },

//   {
//     id: 92,
//     allDay: true,
//     title: 'Some Other Event',
//     start: new Date(2024, 6, 4),
//     end: new Date(2024, 6, 4),
//   },
//   {
//     id: 5,
//     allDay: true,
//     title: 'Conference',
//     start: new Date(2024, 6, 4),
//     end: new Date(2024, 6, 4),
//     desc: 'Big conference for important people',
//   },
//   {
//     id: 6,
//     allDay: true,
//     title: 'Meeting',
//     start: new Date(2024, 6, 4),
//     end: new Date(2024, 6, 4),
//     desc: 'Pre-meeting meeting, to prepare for the meeting',
//   },
//   {
//     id: 7,
//     allDay: true,
//     title: 'Lunch',
//     start: new Date(2024, 3, 12, 12, 0, 0, 0),
//     end: new Date(2024, 3, 12, 13, 0, 0, 0),
//     desc: 'Power lunch',
//   },
//   {
//     id: 8,
//     allDay: true,
//     title: 'Meeting',
//     start: new Date(2024, 3, 12, 14, 0, 0, 0),
//     end: new Date(2024, 3, 12, 15, 0, 0, 0),
//   },
//   {
//     id: 9,
//     allDay: true,
//     title: 'Happy Hour',
//     start: new Date(2024, 3, 12, 17, 0, 0, 0),
//     end: new Date(2024, 3, 12, 17, 30, 0, 0),
//     desc: 'Most important meal of the day',
//   },
//   {
//     id: 10,
//     allDay: true,
//     title: 'Dinner',
//     start: new Date(2024, 3, 12, 20, 0, 0, 0),
//     end: new Date(2024, 3, 12, 21, 0, 0, 0),
//   },
//   {
//     id: 11,
//     allDay: true,
//     title: 'Planning Meeting with Paige',
//     start: new Date(2024, 3, 13, 8, 0, 0),
//     end: new Date(2024, 3, 13, 10, 30, 0),
//   },
//   {
//     id: 11.1,
//     allDay: true,
//     title: 'Inconvenient Conference Call',
//     start: new Date(2024, 3, 13, 9, 30, 0),
//     end: new Date(2024, 3, 13, 12, 0, 0),
//   },
//   {
//     id: 11.2,
//     allDay: true,
//     title: "Project Kickoff - Lou's Shoes",
//     start: new Date(2024, 3, 13, 11, 30, 0),
//     end: new Date(2024, 3, 13, 14, 0, 0),
//   },
//   {
//     id: 11.3,
//     allDay: true,
//     title: 'Quote Follow-up - Tea by Tina',
//     start: new Date(2024, 3, 13, 15, 30, 0),
//     end: new Date(2024, 3, 13, 16, 0, 0),
//   },
//   {
//     id: 12,
//     allDay: true,
//     title: 'Late Night Event',
//     start: new Date(2024, 3, 17, 19, 30, 0),
//     end: new Date(2024, 3, 18, 2, 0, 0),
//   },
//   {
//     id: 12.5,
//     allDay: true,
//     title: 'Late Same Night Event',
//     start: new Date(2024, 3, 17, 19, 30, 0),
//     end: new Date(2024, 3, 17, 23, 30, 0),
//   },
//   {
//     id: 13,
//     allDay: true,
//     title: 'Multi-day Event',
//     start: new Date(2024, 3, 20, 19, 30, 0),
//     end: new Date(2024, 3, 22, 2, 0, 0),
//   },
//   {
//     id: 14,
//     allDay: true,
//     title: 'Today',
//     start: new Date(new Date().setHours(new Date().getHours() - 3)),
//     end: new Date(new Date().setHours(new Date().getHours() + 3)),
//   },
//   // {
//   //   id: 15,
//   // allDay: true,
//   //   title: 'Point in Time Event',
//   //   start: now,
//   //   end: now,
//   // },
//   {
//     id: 16,
//     allDay: true,
//     title: 'Video Record',
//     start: new Date(2024, 3, 14, 15, 30, 0),
//     end: new Date(2024, 3, 14, 19, 0, 0),
//   },
//   {
//     id: 17,
//     allDay: true,
//     title: 'Dutch Song Producing',
//     start: new Date(2024, 3, 14, 16, 30, 0),
//     end: new Date(2024, 3, 14, 20, 0, 0),
//   },
//   {
//     id: 18,
//     allDay: true,
//     title: 'Itaewon Meeting',
//     start: new Date(2024, 3, 14, 16, 30, 0),
//     end: new Date(2024, 3, 14, 17, 30, 0),
//   },
//   {
//     id: 19,
//     allDay: true,
//     title: 'Online Coding Test',
//     start: new Date(2024, 3, 14, 17, 30, 0),
//     end: new Date(2024, 3, 14, 20, 30, 0),
//   },
//   {
//     id: 20,
//     allDay: true,
//     title: 'An overlapped Event',
//     start: new Date(2024, 3, 14, 17, 0, 0),
//     end: new Date(2024, 3, 14, 18, 30, 0),
//   },
//   {
//     id: 21,
//     allDay: true,
//     title: 'Phone Interview',
//     start: new Date(2024, 3, 14, 17, 0, 0),
//     end: new Date(2024, 3, 14, 18, 30, 0),
//   },
//   {
//     id: 22,
//     allDay: true,
//     title: 'Cooking Class',
//     start: new Date(2024, 3, 14, 17, 30, 0),
//     end: new Date(2024, 3, 14, 19, 0, 0),
//   },
//   {
//     id: 23,
//     allDay: true,
//     title: 'Go to the gym',
//     start: new Date(2024, 3, 14, 18, 30, 0),
//     end: new Date(2024, 3, 14, 20, 0, 0),
//   },
//   {
//     id: 24,
//     allDay: true,
//     title: 'DST ends on this day (Europe)',
//     start: new Date(2024, 9, 30, 0, 0, 0),
//     end: new Date(2024, 9, 30, 4, 30, 0),
//   },
//   {
//     id: 25,
//     allDay: true,
//     title: 'DST ends on this day (America)',
//     start: new Date(2024, 10, 6, 0, 0, 0),
//     end: new Date(2024, 10, 6, 4, 30, 0),
//   },
//   {
//     id: 26,
//     allDay: true,
//     title: 'DST starts on this day (America)',
//     start: new Date(2023, 2, 12, 0, 0, 0),
//     end: new Date(2023, 2, 12, 4, 30, 0),
//   },
//   {
//     id: 27,
//     allDay: true,
//     title: 'DST starts on this day (Europe)',
//     start: new Date(2023, 2, 26, 0, 0, 0),
//     end: new Date(2023, 2, 26, 4, 30, 0),
//   },
// ]

export default function PECalender() {
  const [selectedDate, setSelectedDate] = useState();
  const [employee, setEmployee] = useState();
  const [selectedEvent, setSelectedEvent] = useState([]);
  const [events, setEvents] = useState([]);
  const [customeEvent, setCustomeEvent] = useState([]);
  const { userData } = useAuth();
  const role = sessionStorage.getItem("currentRole");

  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { date: paramsDate, name } = useParams();

  // Default Calendar Properties
  const { components } = useMemo(
    () => ({
      components: {
        toolbar: (props) => (
          <CustomToolbar
            {...props}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            getEmployee={getEmployee}
            event={events}
            setEvent={setEvents}
          />
        ),
        event: (props) => <EventComponent {...props} />,
      },
    }),
    [selectedDate]
  );

  // Set Selected Event Details
  const handleEventSelect = (data) => {
    setOpen(true);
    const selectedEventDate = moment(data.start).format("YYYY-MM-DD");
    const eventsForSelectedDate = events.filter(
      (evt) =>
        moment(evt.start).format("YYYY-MM-DD") === selectedEventDate &&
        evt.pe_status == data.title
    );
    setSelectedEvent(eventsForSelectedDate);
  };

  // Event Close
  const handleClose = () => {
    setOpen(false);
    // setTimeout(() => {
    setSelectedEvent([]);
    // }, 10)
  };

  // get Employee Listing

  const getEmployee = async (date, employee) => {
    try {
      setIsLoading(true);
      const getPEEmployee = await post(
        `${process.env.REACT_APP_API_DOTNET_URL}/AdvanceSearch/global`,
        {
          additionalWhere: `FORMAT(Ndate_Increm , 'yyyy-MM') = '${moment(
            date,
            "YYYY-MM-DD"
          ).format("YYYY-MM")}' ${employee ? ` and EmployeeName like '%${employee}%'` : ``
            }  ${role == 'SUPERVISOR' || role == 'REVIEWER' ? ` and (EmployeeID in (SELECT EmployeeID from EmployeeSupervision WHERE   SupervisorEmployeeID= '${userData?.profile?.EmployeeID}' and  SupervisionRole = 'Supervisor') OR SupervisorID = ${userData?.profile?.EmployeeID})` : ``}`,
          tableName: "vw_PerformanceEvaluation",
          searchParams: "[]",
          // searchParams: JSON.stringify([]),
          columns:
            "HrControl ,EmployeeName ,Ndate_Increm ,ID ,days_remaining ,EmployeeID,pe_status",
          pageNumber: 1,
          pageSize: 1000000,
          sortData: "",
          qID: 0,
          location: "global",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem(
              "jwt_access_token"
            )}`,
          },
        }
      );

      if (getPEEmployee?.results) {
        const eventList = getPEEmployee?.results.map((item) => {
          return {
            id: item?.ID,
            title: item?.EmployeeName,
            EmployeeID: item?.EmployeeID,
            Ndate_Increm: item?.Ndate_Increm,
            start: item?.Ndate_Increm,
            end: item?.Ndate_Increm,
            HrControl: item?.HrControl,
            EmployeeName: item?.EmployeeName,
            pe_status: item?.pe_status,
          };
        });

        const fil = eventList.reduce((acc, item) => {
          const key = `${item.pe_status}-${item.Ndate_Increm}`;
          if (!acc[key]) {
            acc[key] = {
              title: item.pe_status,
              count: 0,
              increment_date: item.Ndate_Increm,
              start: item.start,
              end: item.end,
            };
          }
          acc[key].count += 1;
          return acc;
        }, {});

        const statusOrder = {
          "PE Pending": 1,
          "PE Created": 2,
          "PE Completed": 3,
        };

        const newSortedArray = Object.values(fil).sort((a, b) => {
          return statusOrder[a.title] - statusOrder[b.title];
        });

        setCustomeEvent(newSortedArray);
        setEvents(eventList);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  // get events data
  useEffect(() => {
    if (selectedDate) {
      window.history.pushState(
        null,
        "",
        `/pe-calendar/${selectedDate}/${employee || ""}`
      );
      getEmployee(selectedDate, employee);
    }
  }, [selectedDate, employee]);

  //set pramas data

  useEffect(() => {
    if (moment(paramsDate, "YYYY-MM-DD").isValid()) {
      setSelectedDate(paramsDate);
    } else {
      setSelectedDate(moment().format("YYYY-MM-DD"));
    }
    if (name) {
      setEmployee(name);
    }
  }, [paramsDate, name]);

  console.log("sfsdhfjhsdjf", customeEvent);

  return (
    <Card>
      {isLoading && loadingPanel()}
      <CardBody>
        <Calendar
          components={components}
          // defaultDate={selectedDate ? moment(selectedDate, 'YYYY-MM-DD').toString() : moment().toString()}
          date={selectedDate ? selectedDate : moment().format("YYYY-MM-DD")}
          defaultView={Views.MONTH}
          events={customeEvent}
          localizer={mLocalizer}
          views={[Views.MONTH]} // Only allow month view
          step={60}
          allDayMaxRows={2}
          onSelectEvent={handleEventSelect}
        // eventPropGetter={eventPropGetter}
        />
      </CardBody>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth={"sm"}>
        <DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: "0",
            }}
          >
            <h5 className="mt-2">Employee List</h5>
            <div>
              <IconButton onClick={handleClose}>
                <Close />
              </IconButton>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <List sx={{ width: "100%", bgcolor: "background.paper" }}>
            {selectedEvent.length
              ? selectedEvent.map((i) => {
                return (
                  <>
                    <ListItem
                      secondaryAction={
                        <IconButton
                          edge="end"
                          aria-label="delete"
                          onClick={() => {
                            if (i.HrControl) {
                              navigate(
                                `/performance-evaluation/${i.EmployeeID}/${i.id}`
                              );
                            } else {
                              navigate(
                                `/performance-evaluation/${i.EmployeeID}`
                              );
                            }
                          }}
                        >
                          {i.HrControl ? (
                            <Tooltip title={"View PE"}>
                              <Visibility />{" "}
                            </Tooltip>
                          ) : (
                            <Tooltip title={"Initiate PE"}>
                              <Add />
                            </Tooltip>
                          )}
                        </IconButton>
                      }
                    >
                      <ListItemAvatar>
                        <Avatar
                          style={{
                            backgroundColor:
                              i.pe_status == "PE Pending"
                                ? "#FFE0B2"
                                : i.pe_status == "PE Created"
                                  ? "#BBDEFB"
                                  : "#C8E6C9",
                          }}
                        >
                          {i.pe_status == "PE Pending" ? (
                            <Person style={{ color: "#ed6c02" }} />
                          ) : i.pe_status == "PE Created" ? (
                            <Person style={{ color: "#2196F3" }} />
                          ) : (
                            <Person style={{ color: "#4CAF50" }} />
                          )}
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          i.EmployeeName +
                          " " +
                          (i.EmployeeID ? ` / ${i.EmployeeID}` : "")
                        }
                        secondary={
                          <>
                            {/* <p>
                          Employee ID: {i.EmployeeID}
                        </p> */}
                            {i.HrControl && <p>HR Control: {i.HrControl}</p>}
                            {/* <br /> */}

                            <p>
                              Next Increment Date:{" "}
                              {i.Ndate_Increm
                                ? moment(i.Ndate_Increm).format("YYYY-MM-DD")
                                : ""}
                            </p>
                          </>
                        }
                      />
                    </ListItem>
                    <Divider />
                  </>
                );
              })
              : null}

            {/* <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <Work />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary="Work" secondary="Jan 7, 2014" />
            </ListItem>
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <BeachAccess />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary="Vacation" secondary="July 20, 2014" />
            </ListItem> */}
          </List>
        </DialogContent>
      </Dialog>
    </Card>
  );
}
